import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a6bf8ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "customers" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "CODIGO"),
  /*#__PURE__*/_createElementVNode("th", null, "NOMBRE"),
  /*#__PURE__*/_createElementVNode("th", null, "REGION"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA"),
  /*#__PURE__*/_createElementVNode("th", null, "MUNICIPIO"),
  /*#__PURE__*/_createElementVNode("th", null, "TELEFONO"),
  /*#__PURE__*/_createElementVNode("th", null, "STATUS")
], -1))
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.centros, (centro, index) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: index,
        onClick: ($event: any) => ($options.goToCentro(centro))
      }, [
        _createElementVNode("td", null, _toDisplayString(centro.id_center), 1),
        _createElementVNode("td", null, _toDisplayString(centro.unap), 1),
        _createElementVNode("td", null, _toDisplayString(centro.region), 1),
        _createElementVNode("td", null, _toDisplayString(centro.provincia), 1),
        _createElementVNode("td", null, _toDisplayString(centro.municipio), 1),
        _createElementVNode("td", null, _toDisplayString(centro.telefono), 1),
        _createElementVNode("td", null, _toDisplayString(centro.status), 1)
      ], 8, _hoisted_3))
    }), 128))
  ]))
}